import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useEffect, useState} from "react";
import admins from '../../models/admins'
import helpers from "../../helpers/common";
import useRootHook from "../../hooks/useRoot";
import {Add, Check} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Link as RouterLink} from "react-router-dom";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import TableToolbar from '../layout/TableToolbar';

export default function AdminIndex(props) {
    const [adminData, setAdminData] = useState([])
    const {setShowLoader} = useRootHook()

    useEffect(() => {
        setShowLoader(true)
        admins.getData()
            .then((data) => {
                data && setAdminData(data)
                setShowLoader(false)
            }).catch(() => setShowLoader(false))
    }, [])

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Admins"
                breadcrumbs={[['Dashboard', '/'], ['Admins', '/admins']]}
                actions={
                    <Button to="/admins/add" component={RouterLink} variant="contained" startIcon={<Add />}>
                        Add admin
                    </Button>
                }
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
                <TableToolbar title="Admins" />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Username</TableCell>
                            <TableCell>Super</TableCell>
                            <TableCell>Date Created</TableCell>
                            <TableCell>Date Modified</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {adminData.map((row) => (
                            <TableRow key={`admin-${row.id}`}>
                                <TableCell>
                                    <Link color="primary" to={`edit?id=${row.id}`} component={RouterLink}>
                                        {`${row.username}`}
                                    </Link>
                                </TableCell>
                                <TableCell>{row.super ? <Check /> : ''}</TableCell>
                                <TableCell>{helpers.getDate(row.created)}</TableCell>
                                <TableCell>{helpers.getDate(row.modified)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </SectionCard>
        </Grid>
    </React.Fragment>
}


